var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 18,
    viewBox: "0 0 34 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9919 17H8.64372C6.52897 17 4.72633 16.2201 3.2358 14.6603C1.74527 13.1005 1 11.214 1 9.00097C1 6.7879 1.74527 4.90113 3.2358 3.34068C4.72633 1.78023 6.52897 1 8.64372 1H14.9919V3.644H8.64372C7.22941 3.644 6.02292 4.16661 5.02426 5.21181C4.02561 6.25702 3.52628 7.51975 3.52628 9C3.52628 10.4802 4.02561 11.743 5.02426 12.7882C6.02292 13.8334 7.22941 14.356 8.64372 14.356H14.9919V17ZM10.6842 10.322V7.678H23.3158V10.322H10.6842ZM19.0081 17V14.356H25.3563C26.7706 14.356 27.9771 13.8334 28.9757 12.7882C29.9744 11.743 30.4737 10.4802 30.4737 9C30.4737 7.51975 29.9744 6.25702 28.9757 5.21181C27.9771 4.16661 26.7706 3.644 25.3563 3.644H19.0081V1H25.3563C27.471 1 29.2737 1.7799 30.7642 3.33971C32.2547 4.89952 33 6.78596 33 8.99903C33 11.2121 32.2547 13.0989 30.7642 14.6593C29.2737 16.2198 27.471 17 25.3563 17H19.0081Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionLink);
export default __webpack_public_path__ + "static/media/connection-link.ec8e2e213779c5e56b10292e62019834.svg";
export { ForwardRef as ReactComponent };